import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const PlusCircleIcon = ({ fill = 'coolGreyDark', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/2000/svg"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                d="M12.2 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm0 2a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 4a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1Z"
                clipRule="evenodd"
            />
            <mask id="a" width="23" height="22" x="1" y="1" maskUnits="userSpaceOnUse">
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M12.2 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm0 2a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 4a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1Z"
                    clipRule="evenodd"
                />
            </mask>
            <g mask="url(#a)">
                <path className={fillStyles} d="M.2 0h24v24H.2z" />
            </g>
        </svg>
    );
};
